module.exports = __webpack_public_path__ + "img/loading.d152a9e6.gif";